import { useMutation, useQuery } from "react-query";
import {
  addStaff,
  deactivateStaff,
  deleteStaff,
  editStaff,
  getCountries,
  getStaff,
  getStaffs,
  getUser,
  loggedInUser,
  reactivateStaff,
  resendInvite,
} from "../api/account";

const token =
  typeof window !== "undefined" ? localStorage.getItem("token") : null;

const useDataQuery = (queryFn, queryKey, queryParam = null, options = {}) => {
  const { data, isLoading, refetch, isSuccess } = useQuery(
    queryParam ? [queryKey, queryParam] : [queryKey],
    () => queryFn(...(Array.isArray(queryParam) ? queryParam : [queryParam])),
    {
      enabled: options.enabled ?? !!queryParam,
      ...options,
    },
  );
  return { data, isLoading, refetch, isSuccess };
};

const useDataMutation = (mutationFn, mutationKey, options = {}) => {
  const { mutate, isLoading, data } = useMutation(mutationFn, {
    mutationKey,
    ...options,
  });
  return { mutate, isLoading, data };
};

export const useGetUser = (userId, options = {}) =>
  useDataQuery(getUser, "getUser", userId, {
    enabled: !!userId,
    ...options,
  });

export const useGetCountries = (options = {}) =>
  useDataQuery(getCountries, "getCountries", {
    ...options,
  });

export const useGetAllStaffs = (
  pageSize,
  pageNumber,
  status,
  searchParam,
  options = {},
) =>
  useDataQuery(
    getStaffs,
    "getStaffs",
    [pageSize, pageNumber, status, searchParam],
    {
      enabled: !!pageSize && !!pageNumber,
      ...options,
    },
  );

export const useGetStaff = (userId, options = {}) =>
  useDataQuery(getStaff, "getStaff", [userId], {
    enabled: !!userId,
    ...options,
  });

export const useGetLoggedInUser = (options = {}) =>
  useDataQuery(loggedInUser, "loggedInUser", {
    enabled: !!token,
    ...options,
  });

export const useDeleteStaff = (options) =>
  useDataMutation(deleteStaff, "deleteStaff", options);

export const useAddStaff = (options) =>
  useDataMutation(addStaff, "addStaff", options);

export const useEditStaff = (options) =>
  useDataMutation(editStaff, "editStaff", options);

export const useDeactivateStaff = (options) =>
  useDataMutation(deactivateStaff, "deactivateStaff", options);

export const useReactivateStaff = (options) =>
  useDataMutation(reactivateStaff, "reactivateStaff", options);

export const useResendInvite = (options) =>
  useDataMutation(resendInvite, "resendInvite", options);
